import URL_BACKEND from "../config/back-end";

function post(object, api) {
  return new Promise((resolver, reject) => {
    fetch(`${URL_BACKEND}${api}`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ` + sessionStorage.getItem("app-token"),
      },
      body: object && JSON.stringify(object),
    })
      .then(async (response) => {
        const res = await response.json();
        if (response.ok) {
          resolver(res);
          return res;
        } else if (response.status === 403) {
          sessionStorage.clear();
          window.location.reload();
        } else {
          reject(new Error(res.codigo + " : " + res.mensagem));
        }
      })
      .catch((err) => reject(err));
  });
}

export default { post };
